import { Injectable } from '@angular/core';
import { DatePickerMode } from './date-picker-mode.enum';
import type { DateTimeFormatType } from '../../../services/date/date-formatter.service';

/**
 * Default configurations for date picker component
 */
@Injectable()
export class DatePickerConfig {
  mode: DatePickerMode = DatePickerMode.DAY;
  minMode: string = DatePickerMode.DAY;
  maxMode: string = DatePickerMode.YEAR;
  startingDay: number = 0;
  yearRange: number = 20;
  showWeeks: boolean = false;
  formatDay: DateTimeFormatType = 'DAY';
  formatMonth: DateTimeFormatType = 'MONTH_FULL';
  formatYear: DateTimeFormatType = 'YEAR';
  formatDayHeader: DateTimeFormatType = 'DAY_OF_WEEK';
  formatDayTitle: DateTimeFormatType = 'MONTH_YEAR_FULL';
  formatMonthTitle: DateTimeFormatType = 'YEAR';
  required: boolean = false;
}
